import {normalizeEuro} from '@amo/core/utils/normalize';

const RecapTarif = (props) => {
    const {
        prixTotalMensuelPromo,
        prixTotalMensuel,
        prixTotalAnnuelPromo,
        prixTotalAnnuel,
        codePromo,
        fractionnementChoisi,
    } = props;

    const isAnnuel = fractionnementChoisi === 'A';
    const hasPromo = codePromo?.Eligible && (
        isAnnuel
            ? prixTotalAnnuelPromo < prixTotalAnnuel
            : prixTotalMensuelPromo < prixTotalMensuel
    );

    const prixPrincipal = isAnnuel
        ? (hasPromo ? prixTotalAnnuelPromo : prixTotalAnnuel)
        : (hasPromo ? prixTotalMensuelPromo : prixTotalMensuel);
    const prixPrincipalBarre = isAnnuel ? prixTotalAnnuel : prixTotalMensuel;

    return (
        <div className="row text-left">
            <div className="col-lg-8 col-md-7 col-sm-12">
                <p
                    className="card-title text-primary fw-bolder pt-3"
                    style={{textAlign: 'left'}}
                >
                    Mon tarif
                </p>
            </div>
            <div className="col-lg-4 col-md-5 col-sm-12">
                <div className="d-flex justify-content-between">
                    <div className="col-lg-7 col-6 text-end">
                        <span className="f-26 fw-bold text-secondary" style={hasPromo ? {lineHeight: 1} : undefined}>
                            {normalizeEuro(prixPrincipal)}
                        </span>
                        {hasPromo && (
                            <span className="f-14 text-dark d-block" style={{textDecoration: 'line-through', marginTop: '-4px'}}>
                                {normalizeEuro(prixPrincipalBarre)}
                            </span>
                        )}
                    </div>
                    <div className="col-lg-5 col-6 fw-light mt-2 text-start ps-2">
                        <p className="mb-0 f-14">
                            {isAnnuel ? '/ an' : '/ mois'}
                            {!isAnnuel && (
                                <small className="f-10 d-block">
                                    soit {normalizeEuro((hasPromo ? prixTotalMensuelPromo : prixTotalMensuel) * 12)} par an
                                </small>
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecapTarif;
